import React from 'react';

import { CustomRow } from 'src/presentation/components/forms/CustomRow';
import { FIELD_MAPPER } from '../ThreadsConstants';
import { FirstColumn, SecondColumn, ThreadSection } from 'src/presentation/components/pages/threads/ThreadsLayouts';
import TextareaField from 'src/presentation/components/forms/TextareaField';

const ErrorSection = () => (
  <>
    <FirstColumn>
      <ThreadSection header="Thread messages" description="Thread-specific messages sent to the customer.">
        <CustomRow>
          <TextareaField
            label={FIELD_MAPPER.ERROR.label}
            description={FIELD_MAPPER.ERROR.description}
            data-aid={FIELD_MAPPER.ERROR.path}
            attr={FIELD_MAPPER.ERROR.path}
            placeholder={FIELD_MAPPER.ERROR.placeholder}
          />
        </CustomRow>
      </ThreadSection>
    </FirstColumn>
    <SecondColumn></SecondColumn>
  </>
);

export default ErrorSection;
